// extracted by mini-css-extract-plugin
export default {"container":"Products_container__zzvsl","products":"Products_products__UdBBG","menu":"Products_menu__FfipS","list":"Products_list__RAPKQ","product":"Products_product__d7maQ"};